import { sortEmployerUsers } from 'utils/clickme';
import { getTomorrowDate } from 'utils/date';

import { toDate } from 'bloko/blocks/calendar/datesHelper';

import { Match, Requirements } from 'app/routes';

import { Action } from 'store/createReducer';
import {
    AccountCreateInfo,
    resetAccountsAccountInfo,
    setAccountsAccountId,
    setAccountsAccountTitle,
    setAccountsAccountUsers,
    setAccountsEmployerUsers,
    setAccountsExpiredDate,
    setAccountsIsContractExist,
    setAccountsPricePerClick,
    User,
} from 'store/models/accounts';

const isAccountEdit = (match: Match['match']) => match?.params.accountId;

export const AccountCreateRequirements: Requirements<{
    employerUsers: User[];
    account: AccountCreateInfo;
}> = {
    methods: ({ match }) => {
        const accountId = parseInt(match ? match.params.accountId : '', 10);
        return {
            employerUsers: { url: '/api/v1/user/employer_users', cacheable: false },
            ...(isAccountEdit(match) && {
                account: { url: `/api/v1/account?accountId=${accountId}`, cacheable: false },
            }),
        };
    },
    resolve: ({ result: { employerUsers, account } }) => {
        const actions = [
            setAccountsEmployerUsers(sortEmployerUsers(Object.values(employerUsers))),
            resetAccountsAccountInfo(null),
        ];
        const editActions: Action[] = [];
        if (account) {
            const { id, title, userIds, expiredDate, pricePerClickInCents } = account;
            editActions.push(
                setAccountsAccountId(id),
                setAccountsAccountTitle(title),
                setAccountsAccountUsers(userIds.map((id) => id.toString()))
            );
            editActions.push(
                setAccountsExpiredDate(expiredDate ? toDate(expiredDate) : getTomorrowDate()),
                setAccountsPricePerClick(pricePerClickInCents ? pricePerClickInCents / 100 : null),
                setAccountsIsContractExist(Boolean(expiredDate && pricePerClickInCents))
            );
        } else {
            editActions.push(setAccountsExpiredDate(getTomorrowDate()), setAccountsPricePerClick(null));
        }
        return [...actions, ...editActions];
    },
};
